import useSWR from "swr"

export const useBanners = () => useSWR("/banners")